import React from 'react';

import Participant from './Participant';

function Participants(props) {
  var participants = props.participants.map((participant) => {
    return (
      <Participant key={participant.id} participant={participant} />
    )
  })

  return (
    <table className="participants">
      <tbody>
        <tr>
          {participants}
        </tr>
      </tbody>
    </table>
  )
}

export default Participants;
